import type { IconProps } from './IconBase'

const baseUrl = process.env.REACT_APP_CONFIG_BASE_URL + 'assets/'

export const IconBell = (props: IconProps) => (
  <img src={baseUrl + 'bell.gif'} style={{ height: props.size + 'px' }} />
)
